import { useState, useEffect } from "react";

const CamTest = () => {
  const [cameraStatus, setCameraStatus] = useState(null);
  const [micStatus, setMicStatus] = useState(null);
  const [stream, setStream] = useState(null);
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    checkPermissions();
  }, []);

  const checkPermissions = async () => {
    try {
      if (navigator.permissions) {
        const cameraPermission = await navigator.permissions.query({
          name: "camera",
        });
        const micPermission = await navigator.permissions.query({
          name: "microphone",
        });

        setCameraStatus(cameraPermission.state);
        setMicStatus(micPermission.state);

        cameraPermission.onchange = () => {
          setCameraStatus(cameraPermission.state);
          handlePopupVisibility(cameraPermission.state, micPermission.state);
        };
        micPermission.onchange = () => {
          setMicStatus(micPermission.state);
          handlePopupVisibility(cameraPermission.state, micPermission.state);
        };

        handlePopupVisibility(cameraPermission.state, micPermission.state);
      }
    } catch (err) {
      console.error("Permission check error:", err);
    }
  };

  const handlePopupVisibility = (cameraState, micState) => {
    if (cameraState === "denied" || micState === "denied") {
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  };

  const requestMediaAccess = async () => {
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });
      setStream(mediaStream);
      setError(null);
      setShowPopup(false);
    } catch (err) {
      console.error("Media access error:", err);
      setError("Permission denied. Please allow access in browser settings.");
      setShowPopup(true);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold">Camera & Microphone Access</h2>

      <p className="mt-2">
        🎥 Camera: <strong>{cameraStatus || "Checking..."}</strong>
      </p>
      <p>
        🎤 Microphone: <strong>{micStatus || "Checking..."}</strong>
      </p>

      <button
        className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md"
        onClick={requestMediaAccess}
      >
        Request Access
      </button>

      {error && <p className="text-red-600 mt-2">{error}</p>}

      {stream && (
        <video
          autoPlay
          playsInline
          className="mt-4 w-64 border border-gray-300"
          ref={(video) => video && (video.srcObject = stream)}
        />
      )}

      {/* Helper Popup if one or both permissions are denied */}
      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-gray-900 bg-opacity-75">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <h3 className="text-lg font-bold mb-2">⚠️ Allow Camera & Microphone</h3>
            <p className="text-sm mb-4">
              Camera and/or microphone access is blocked. Please enable them in your browser
              settings.
            </p>
            <div className="flex justify-center gap-4">
              <button
                className="px-4 py-2 bg-green-500 text-white rounded-md"
                onClick={requestMediaAccess}
              >
                Retry
              </button>
              <button
                className="px-4 py-2 bg-gray-400 text-white rounded-md"
                onClick={() => setShowPopup(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CamTest;
